import styled from "styled-components";

export const StyledSlideProductDiv = styled.div`
  background-color: #fff;
  height: 115px;
  width: 100%;
`;
